import { z } from 'zod';

/** GET /api/search?q=&limit= — global search behind the command palette (⌘K). */
export const SearchQuery = z.object({
  q: z.string().trim().min(1).max(200),
  limit: z.coerce.number().int().min(1).max(25).default(8),
});
export type SearchQuery = z.infer<typeof SearchQuery>;

export const SEARCH_RESULT_TYPES = ['business', 'contact', 'opportunity', 'note'] as const;
export type SearchResultType = (typeof SEARCH_RESULT_TYPES)[number];

/**
 * One search hit. Every result belongs to a business (lead) — the palette navigates to
 * `/leads/<businessId>` (with `?tab=opportunities` for opportunity hits).
 */
export type SearchResultDTO = {
  type: SearchResultType;
  id: string;
  businessId: string;
  title: string;
  subtitle: string | null;
};

export type SearchResponse = { results: SearchResultDTO[] };
